const apiKey = process.env.NEXT_PUBLIC_GOOGLE_API_KEY_WEB ?? '';
const mapZoom = '7';

const counties = [
  {
    id: 1,
    county: 'østfold',
  },
  {
    id: 2,
    county: 'akershus',
  },
  {
    id: 3,
    county: 'akershus',
  },
  {
    id: 4,
    county: 'hedmark',
  },
  {
    id: 5,
    county: 'oppland',
  },
  {
    id: 6,
    county: 'buskerud',
  },
  {
    id: 7,
    county: 'vest+fold',
  },
  {
    id: 8,
    county: 'telemark',
  },
  {
    id: 9,
    county: 'aust+agder',
  },
  {
    id: 10,
    county: 'vest+agder',
  },
  {
    id: 11,
    county: 'rogaland',
  },
  {
    id: 12,
    county: 'hordaland',
  },
  {
    id: 14,
    county: 'sogn+og+fjordane',
  },
  {
    id: 15,
    county: 'møre+og+romsdal',
  },
  {
    id: 16,
    county: 'sør+trøndelag',
  },
  {
    id: 17,
    county: 'nord+trøndelag',
  },
  {
    id: 18,
    county: 'nordland',
  },
  {
    id: 19,
    county: 'troms',
  },
  {
    id: 20,
    county: 'finnmark',
  },
  {
    id: 50,
    county: 'nord+trøndelag',
  },
];

let maps = {} as any;

counties.forEach((county) => {
  maps[
    county.id
  ] = `https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${county.county},Norway&zoom=${mapZoom}&region=NO`;
});

export default maps;
